if (!customElements.get('promotion-banner-carousel')) {
  customElements.define(
    'promotion-banner-carousel',
    class PromotionBannerCarousel extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        if (!this.enableSlider) return;

        this.controls = this.querySelector('.promotion-banner__controls');
        this.initSlider();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      initSlider() {
        if (typeof FoxTheme === 'undefined' || !FoxTheme.Carousel) return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          navigation: false,
          pagination: false
        };

        if (this.controls) {
          this.sliderOptions.navigation = {
            nextEl: this.controls.querySelector('.swiper-button-next'),
            prevEl: this.controls.querySelector('.swiper-button-prev')
          };
          this.sliderOptions.pagination = {
            el: this.controls.querySelector('.swiper-pagination'),
            clickable: true
          };
        }

        const modules = [];
        if (FoxTheme.Swiper && FoxTheme.Swiper.EffectFade) {
          modules.push(FoxTheme.Swiper.EffectFade);
        }

        this.sliderInstance = new FoxTheme.Carousel(this, this.sliderOptions, modules);
        this.sliderInstance.init();
      }

      destroySlider() {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
